import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

type DataHeaderProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const DataHeader = (props: DataHeaderProps) => (
  <div className={classNames(props.className, 'tds-data-header')} {...omit(props, 'className')} />
);

type DataHeaderLabelProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

export const DataHeaderLabel = (props: DataHeaderLabelProps) => (
  <span className={classNames('tds-data-header-label', props.className)} {...omit(props, 'className')} />
);
